import { useState, useRef, useEffect } from "react";
import { callAIApi } from "../services/apiService";
import { v4 as uuidv4 } from 'uuid';
import SpeechRecognition, {
  useSpeechRecognition,
  ListeningOptions
} from 'react-speech-recognition';

function PptAI() {
    const [messages, setMessages] = useState<string[]>([]);
    const [loading, setLoading] = useState(false);
    const [current_user_chat_code, setCurrent_user_chat_code] = useState("");
    const [lastTranscript, setLastTranscript] = useState("");
    const [ppt, setPpt] = useState("");

    const inactivityTimeoutRef = useRef<NodeJS.Timeout | null>(null);

    const {
        transcript,
        listening,
        resetTranscript,
        browserSupportsSpeechRecognition
    } = useSpeechRecognition();

    useEffect(() => {
        setCurrent_user_chat_code(uuidv4());
    }, []);

    useEffect(() => {
        if (!transcript || transcript === lastTranscript) return;

        if (inactivityTimeoutRef.current) {
        clearTimeout(inactivityTimeoutRef.current);
        }

        inactivityTimeoutRef.current = setTimeout(() => {
        const clean = transcript.trim();
        if (clean) {
            setMessages((prev) => [...prev, clean]);
            setLastTranscript(clean);
            resetTranscript();
        }
        }, 1000);
    }, [transcript]);

    const handleBotReply = async () => {
        const fullConversation = messages.join(" ");
        if (!fullConversation.trim()) return;

        try {
        setLoading(true);

        const formData = new FormData();
        formData.append("userQuery", fullConversation);
        formData.append("current_user_chat_code", current_user_chat_code);

        const response = await callAIApi(formData);
        const reply = JSON.parse(response.reply) || "No response";
        
            

        } catch (error) {
        console.error(error);
        } finally {
        setLoading(false);
        }
    };

    if (!browserSupportsSpeechRecognition) {
        return <div>Browser doesn't support speech recognition</div>;
    }

    return (
        <div className="w-full h-screen flex flex-col bg-white">
            <div className="bg-blue-600 text-white text-center py-4 text-xl font-semibold shadow-md">
                PPT Assistant
            </div>

            <div className="flex w-full h-full">
                <div className="bg-gray-100 w-[80%] flex items-center justify-center">
                    <button
                        onClick={() => {
                        const options: ListeningOptions = {
                            continuous: true,
                            language: 'en-US',
                        };
                        SpeechRecognition.startListening(options);
                        }}
                        disabled={loading}
                        className="px-5 py-3 font-bold rounded text-white bg-red-500 hover:bg-red-600 transition-colors"
                    >
                        Start Call
                    </button>
                </div>

                <div className="w-[20%] bg-gray-200 flex flex-col items-center justify-start pt-6 space-y-4">
                    
                    <div
                        className={`px-4 py-3 rounded-lg whitespace-pre-line ${
                            loading
                            ? "bg-white-500 text-black self-start mr-auto"
                            : "bg-gray-100 text-black max-w-[70%] self-start mr-auto"
                        }`}
                        dangerouslySetInnerHTML={{
                            __html:
                            loading 
                                ? `<div class="flex items-center space-x-2">
                                    <span class="text-sm">Loading</span>
                                    <div class="flex space-x-1">
                                    <div class="h-2 w-2 bg-gray-600 rounded-full animate-bounce" style="animation-delay: 0s;"></div>
                                    <div class="h-2 w-2 bg-gray-600 rounded-full animate-bounce" style="animation-delay: 0.1s;"></div>
                                    <div class="h-2 w-2 bg-gray-600 rounded-full animate-bounce" style="animation-delay: 0.2s;"></div>
                                    </div>
                                </div>`
                                : ppt,
                        }}
                    />

                    <div className="w-[90%] bg-white p-2 rounded shadow text-xs text-gray-800 h-[60%] overflow-y-auto">
                        <p className="font-semibold mb-1">Live Transcript:</p>
                        {messages.map((msg, index) => (
                        <p key={index} className="mb-1">• {msg}</p>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default PptAI;
